import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { availableReservoirPredictionsQuery } from '~/pages/System/api/availableReservoirPredictions.queries';
import { ReservoirPredictionsAvailabilityModel } from '~/pages/System/models/ReservoirPredictionsAvailabilityModel';
import { getSystemQuery } from '~/shared/api/system.queries';
import { checkAuthorization } from '~/shared/auth/auth-utils';
import { SystemModel } from '~/shared/models/system/SystemModel';
import { assertIsDefined } from '~/types/assert-type';

export type ReservoirParametersSidebarSectionLoaderResult = {
  reservoirPredictionsAvailability: ReservoirPredictionsAvailabilityModel;
};

export const reservoirParametersSidebarSectionLoader =
  (queryClient: QueryClient) =>
  async ({ params, request }: LoaderFunctionArgs) => {
    await checkAuthorization(queryClient, request);

    const { systemId, reservoirId } = params;

    assertIsDefined(reservoirId);

    assertIsDefined(systemId);

    const system = await queryClient.ensureQueryData(getSystemQuery(systemId));

    const systemModel = new SystemModel({ system });

    const reservoir = systemModel.reservoirById(reservoirId);

    assertIsDefined(reservoir);

    if (
      !ReservoirPredictionsAvailabilityModel.shouldCheckReservoirPredictions(
        systemModel,
      )
    ) {
      return {
        reservoirPredictionsAvailability:
          ReservoirPredictionsAvailabilityModel.fromEmptyEventResponse(),
      };
    }

    const reservoirPredictionsAvailability = await queryClient.ensureQueryData(
      availableReservoirPredictionsQuery({
        resourceName: reservoir.name,
      }),
    );

    return {
      reservoirPredictionsAvailability,
    };
  };
